import React from 'react'

import { Stepper } from '../../../../../../common/inputs/stepper/Stepper'
import { FieldProps } from '../../../../../../../@types/types'
import { WhoWeLookForScreenValidationResult } from '../../../../../../../@types/validation-types'

const NumberOfMaleFlatMates: React.FC<FieldProps<WhoWeLookForScreenValidationResult>> = ({
  validationMessages,
  insertionData,
  screenName,
  onChange,
}) => (
  <div className='margin-top-m palm-one-whole lap-one-half desk-one-half lap-padding-right-m desk-padding-right-m'>
    <Stepper
      id='number-of-male-flat-mates'
      propertyName='numberOfMaleFlatMates'
      placeholder=''
      label='wizard.screen.whoWeLookFor.numberOfMaleFlatMates'
      input={insertionData.numberOfMaleFlatMates}
      type='tel'
      maxLength={4}
      max={999}
      errors={validationMessages!.numberOfMaleFlatMates ?? []}
      doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
    />
  </div>
)

export default NumberOfMaleFlatMates
